module.exports = __webpack_public_path__ + "static/media/vday3.54407727.jpeg";